import { useQuery } from "@tanstack/react-query";
import { adaptCarouselBanners } from "src/features/vendorSponsorship/adapters/adaptCarouselBanners";
import cmsClient from "src/services/cmsClient";

const fetchBannerLibrary = async () => {
	const response = await cmsClient.get<IBanner[]>(
		"/homepage/admin/fullscreentakeover/",
		{
			params: {
				published: false
			}
		}
	);

	return response.data;
};

interface Options {
	onSuccess?: (banners: Banner[]) => void;
}

const useFullScreenTakeoverBannerLibrary = (options: Options = {}) => {
	const query = useQuery(
		["full-screen-takeover-banner-library"],
		fetchBannerLibrary,
		{
			select: adaptCarouselBanners,
			...options
		}
	);

	return query;
};

export default useFullScreenTakeoverBannerLibrary;
